import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components';
import type { DataCell } from '../../types';
import { GetColor, getAppTitle } from 'venn-ui-kit';
import NewErrorEditor from './NewErrorEditor';

interface NewErrorEditorRowProps {
  /**
   * Cell to edit
   */
  cell: DataCell;
  date: string;
  valid?: boolean;
  errors: string[];
  /**
   * Returns the updated value
   */
  onBlur: (value: string) => void;
  isPrice: boolean;
}

export const NewErrorEditorRow: FC<React.PropsWithChildren<NewErrorEditorRowProps>> = (props) => {
  const { errors, valid, cell, isPrice } = props;
  return (
    <>
      <Container>
        <Description valid={!!valid}>
          &nbsp;
          {getDescription(errors)}
          {isPrice && Number(cell.value) < 0 && ` – ${getAppTitle()} does not support negative prices`}
        </Description>
        <NewErrorEditor {...props} />
      </Container>
      <div className="h-[1px] bg-venn-grey-30" />
    </>
  );
};

const getDescription = (errors: string[]) => errors.join(' / ');

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  border-bottom: 1px solid ${GetColor.GreyScale.Grey20};
`;

interface DescriptionProps {
  valid: boolean;
}

const Description = styled.div<DescriptionProps>`
  font-size: 12px;
  font-weight: 400;
  color: ${GetColor.Error};
`;

export default NewErrorEditorRow;
